export const HOME_ROUTE = "/";
export const LOGIN_ROUTE = "/";
export const REGISTRATION_REQUEST_ROUTE = "/solicitar-cadastro";
export const FALE_CONOSCO_ROUTE = "/fale-conosco";
